export default __webpack_public_path__ + "static/media/(45).6c10c3ba.jpg";